import { Business } from '@40seas/entities/businesses';
import { Partial } from '@40seas/entities/common';

export class UpdateBusinessDto extends Partial(Business) {}
